import React, { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { createStyles, IconButton, ListItemIcon, Menu, MenuItem, Typography, withStyles } from '@material-ui/core';
import { Check, Language } from '@material-ui/icons';
import { map } from 'lodash';

import { changeLocale } from '@lib/actions';
import { Locale, locales } from '@lib/providers/LanguageProvider';
import { selectLocale } from '@lib/selectors';

const mappingLocales = {
  [Locale.EnglishUS]: 'English',
  [Locale.SpanishUS]: 'Español',
  [Locale.PortugueseBR]: 'Português',
};

const styles = () =>
  createStyles({
    button: {
      outline: 'none',
      '&:focus': {
        outline: 'none',
      },
    },
    menuItemRoot: {
      minWidth: 110,
      '& svg': {
        visibility: 'hidden',
      },
    },
    menuItemSelected: {
      '& svg': {
        visibility: 'initial',
      },
      '& p': {
        fontWeight: 600,
      },
    },
  });

export interface LanguageSelectorProps {
  classes: any;
}

const LanguageSelector: React.FC<LanguageSelectorProps> = ({ classes }) => {
  const dispatch = useDispatch();
  const currentLocale = useSelector(selectLocale);

  const [anchorEl, setAnchorEl] = useState<any>();

  const handleChange = useCallback(
    (locale: Locale) => {
      setAnchorEl(undefined);
      dispatch(changeLocale(locale));
    },
    [dispatch, setAnchorEl],
  );

  return (
    <div>
      <IconButton
        className={classes.button}
        aria-label="Language Menu"
        aria-owns={anchorEl ? 'languageMenu' : undefined}
        aria-haspopup="true"
        onClick={(event) => setAnchorEl(event.currentTarget)}
      >
        <Language />
      </IconButton>
      <Menu id="languageMenu" anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(undefined)}>
        {map(locales, (locale) => (
          <MenuItem
            key={locale}
            classes={{
              root: classes.menuItemRoot,
              selected: classes.menuItemSelected,
            }}
            selected={locale === currentLocale}
            onClick={() => handleChange(locale)}
          >
            <ListItemIcon>
              <Check fontSize="small" />
            </ListItemIcon>
            <Typography variant="body2">{mappingLocales[locale]}</Typography>
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

export default withStyles(styles)(LanguageSelector);
